import { useState, useEffect, useContext } from "react";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Button, TextField } from "@material-ui/core";
import { UserContext } from "../../context/UserContext";
import axios from "axios";
import ChipControl from "./ChipControl";

export default function CreatePost({
  defaultPost,
  setPost,
  post,
  closeForm,
  setCloseForm,
}) {
  const { user } = useContext(UserContext);
  const [pic, setPic] = useState("");
  // const [tags, setTags] = useState([]);

  // useEffect( async ()=>{

  //     let localtags = await  axios.get('api/user/skills');
  //     setTags(localtags.data);
  //     console.log(tags);

  // }, [])

  let key_name, val;
  const handleInputs = (e) => {
    key_name = e.target.name;
    val = e.target.value;
    setPost({ ...post, [key_name]: val });
  };

  const handleSubmit = () => {
    setPost(() => ({ ...post, pic }));
    axios
      .put(
        `api/invitation/${post._id}`,
        {
          pic,
          ...post,
        },
        {
          headers: {
            "x-auth-token": localStorage.getItem("user"),
          },
        }
      )
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleImage = (pics) => {
    if (pics === undefined) {
      console.log("Enter pics");
      return;
    }

    if (pics.type === "image/jpeg" || pics.type === "image/png") {
      const data = new FormData();
      data.append("file", pics);
      data.append("upload_preset", "chat-app");
      data.append("cloud_name", "dn2lwhcyf");
      fetch("https://api.cloudinary.com/v1_1/dn2lwhcyf/image/upload", {
        method: "post",
        body: data,
      })
        .then((res) => res.json())
        .then((data) => {
          console.log(data);
          setPic(data.url.toString());
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      return;
    }
  };

  return (
    <>
      <form encType="multipart/form-data">
        <div className="user_items">
          <TextField
            label="Title"
            name="title"
            defaultValue={post.title}
            value={post.title}
            onChange={handleInputs}
            InputLabelProps={{ className: "textfield__label" }}
          />
        </div>

        <div className="user_items">
          <TextField
            label="Tech Stack"
            name="techStack"
            defaultValue={post.techStack}
            value={post.techStack}
            onChange={handleInputs}
            InputLabelProps={{ className: "textfield__label" }}
          />
        </div>

        <div className="user_items">
          <TextField
            label="About"
            name="about"
            defaultValue={post.about}
            value={post.about}
            multiline
            rows={4}
            onChange={handleInputs}
            InputLabelProps={{ className: "textfield__label" }}
            TextField={{ className: "textfield__border" }}
          />
        </div>

        <div className="user_items">
          <TextField
            label="Requirements"
            name="requirements"
            defaultValue={post.requirements}
            value={post.requirements}
            multiline
            rows={4}
            onChange={handleInputs}
            InputLabelProps={{ className: "textfield__label" }}
            TextField={{ className: "textfield__border" }}
          />
        </div>

        <div className="user_items">
          {/* <ChipControl tags={tags} /> */}
          {/* <FormControl style={{ width: "100%", marginTop: 15 }}>
            <InputLabel style={{ color: "rgb(187, 187, 187)" }}>
              Category
            </InputLabel>
            <Select
              autoWidth={true}
              style={{ color: "rgb(187, 187, 187)" }}
              value={post.category}
              label="Category"
              name="category"
              // InputLabelProps={{ className: 'textfield__label' }}
              onChange={handleInputs}
            >
              <MenuItem style={{ backgroundColor: "none" }}>
                <em>~Select Category~</em>
              </MenuItem>
              {tags.map((cat) => (
                <MenuItem key={cat} value={cat}>
                  {cat}
                </MenuItem>
              ))}
            </Select>
          </FormControl> */}
        </div>

        {/* UPLOAD IMAGES */}
        <div className="user_items user_items2">
          <h3 className="textfield__label">Upload Image</h3>
          <label className="upload" htmlFor="upload_resume">
            <p>+</p>
          </label>
          <input
            type="file"
            id="upload_resume"
            name="img"
            accept="image/*"
            onChange={(e) => handleImage(e.target.files[0])}
            hidden
          />
        </div>
        {/* closes UPLOAD IMAGES */}

        <div className="user_items user_btns">
          <Button
            className="update_btn"
            variant="contained"
            onClick={(e) => {
              e.preventDefault();
              // handleImageUpload();
              handleSubmit(e);
              setCloseForm(!closeForm);
            }}
          >
            UPDATE
          </Button>

          <Button
            className="del_btn"
            variant="contained"
            onClick={(e) => {
              e.preventDefault();
              setPost(defaultPost);
              setCloseForm(!closeForm);
            }}
          >
            CLOSE
          </Button>
        </div>
      </form>
    </>
  );
}
